/* Sika 2 Nov 2026: "None" is translated on the storefront (Ingen / Keine / Ninguno), so match all languages */
/* Sika 2 Nov 2026: hint under "add to basket" when the back-cushion choice is missing */
window.__sikaHint = window.__sikaHint || function (modal, show) {
  const hint = modal && modal.querySelector('#pop-up-choice-hint');
  if (!hint) return;
  hint.hidden = !show;
  if (show) {
    hint.classList.remove('is-pulsing');
    void hint.offsetWidth;
    hint.classList.add('is-pulsing');
  }
};
window.__sikaIsNone = window.__sikaIsNone || function (t) {
  const v = String(t || '').trim().toLowerCase();
  return v.includes('none') || ['ingen', 'keine', 'kein', 'ninguno', 'ninguna', 'nada', 'sin cojín', 'sin cojin'].includes(v);
};

class CushionVariantSync extends HTMLElement {
  constructor() {
    super();
    this.syncCushionData = this.syncCushionData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.intervalId = null;
    this._isPopupOpen = false;
  }

  /* -----------------------------
     Getters
  ----------------------------- */
  get section() { return this.closest('.shopify-section'); }
  get dynamicText() { return this.section?.querySelector('.js-dynamic-add-back-cushion-text'); }
  get lastBlock() { return this.section?.querySelector('.js-variant-last-block'); }
  get infoBlock() { return this.closest('.shopify-section')?.querySelector('.js-dynamic-cushion-info'); }

  /* -----------------------------
     Lifecycle
  ----------------------------- */
  connectedCallback() {
    this.productFormId = this.getAttribute('form');
    this.productForm = document.getElementById(this.productFormId);
    this.addEventListener('change', this.handleChange);
    this.addEventListener('click', this.handleClick);
    this.restoreSelection();
    this.startAutoSync();
    if (this.productForm) {
      this.productForm.addEventListener('submit', this.handleFormSubmit, true);
    }
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.productForm) {
      this.productForm.removeEventListener('submit', this.handleFormSubmit, true);
    }
  }

  /* -----------------------------
     Restore + Auto Sync
  ----------------------------- */
  restoreSelection() {
    if (window.__cushionChoice) {
      const savedCb = this.querySelector(`#${window.__cushionChoice}`);
      if (savedCb) {
        savedCb.checked = true;
        savedCb.setAttribute('checked', 'checked');
      }
    }
    this.syncCushionData(false);
  }

  startAutoSync() {
    this.intervalId = setInterval(() => {
      if (window._isProductPopupOpen) return;
      this.enforceSelection();
      this.checkDynamicTextSync();
    }, 10);
  }

  enforceSelection() {
    if (!window.__cushionChoice) return;
    const savedCb = this.querySelector(`#${window.__cushionChoice}`);
    if (savedCb && !savedCb.checked) {
      savedCb.checked = true;
      savedCb.setAttribute('checked', 'checked');
    }
  }

  checkDynamicTextSync() {
    const radio = this.querySelector('input[name="choice"]:checked');
    if (!radio || !this.dynamicText) return;
    const label = this.getLabelText(radio);
    if (this.dynamicText.textContent !== label) {
      this.syncCushionData(false);
    }
  }

  /* -----------------------------
     Form Submit
  ----------------------------- */
  handleFormSubmit(e) {
    if (window._isProductPopupOpen || window._popupConfirmed) return;

    // 1. Detect Option 2 state
    const form = e.target;
    const option2Inputs = Array.from(document.querySelectorAll('input[data-option-position="2"], select[data-option-position="2"]'))
      .filter(input => input.form === form);
    
    // Check if the product has a "None" option available for Option 2
    const hasNoneOption = option2Inputs.some(input => {
      const val = (input.tagName === 'SELECT') ? Array.from(input.options).some(o => window.__sikaIsNone(o.text)) : window.__sikaIsNone(input.getAttribute('data-option-value'));
      return val;
    });

    const option2Input = option2Inputs.find(input => (input.checked || (input.tagName === 'SELECT')));

    let optionValue = '';
    if (option2Input) {
      if (option2Input.tagName.toLowerCase() === 'select') {
        optionValue = option2Input.options[option2Input.selectedIndex]?.textContent || '';
      } else {
        optionValue = option2Input.getAttribute('data-option-value') || option2Input.value || '';
      }
    }
    
    const isOption2None = option2Input && window.__sikaIsNone(optionValue);

    const hasAddTag = this.getAttribute('data-has-add-tag') === 'true';

    let requiresCushion = false;
    let requiresOption2 = false;

    // 1. Tag-Based Popup Logic
    const hasCushionChoice = !!this.querySelector('input[name="choice"]');
    const selected = this.querySelector('input[name="choice"]:checked');
    if (hasCushionChoice && !selected) {
      requiresCushion = true;
    }

    // 2. Variant-Based Popup Logic (Always / All Time)
    // ONLY triggers if the product DOES NOT have the "Add" tag
    // AND if the product DOES NOT have a "None" option available in its list
    if (!hasAddTag && !hasNoneOption && !isOption2None && option2Input) {
      requiresOption2 = true;
    }

    if (requiresCushion || requiresOption2) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      this.openPopUp(requiresCushion, requiresOption2);
      return false;
    }
  }

  /* -----------------------------
     Popup
  ----------------------------- */
  openPopUp(requiresCushion = true, requiresOption2 = false) {
    window._isProductPopupOpen = true;
    window._popupConfirmed = false;
    this.requiresCushion = requiresCushion;
    this.requiresOption2 = requiresOption2;
    const modal = document.getElementById('product-pop-up');
    if (!modal) return;
    this.populatePopUp();
    modal.setAttribute('open', '');
    if (typeof modal.showModal === 'function') modal.showModal();
  }

  populatePopUp() {
    const modal = document.getElementById('product-pop-up');
    const popupMaterials = document.getElementById('pop-up-selected-materials');
    if (!popupMaterials || !modal) return;
    const dataBlocks = this.section.querySelectorAll('.selected-data_content .s-data_block');
    let html = '';
    dataBlocks.forEach((block) => {
      const titleElement = block.querySelector('.s-data_title');
      const valueElement = block.querySelector('.s-data_text');
      if (!titleElement || !valueElement) return;
      const title = titleElement.textContent.trim();
      let value = valueElement.textContent.trim().replace('TEJIDO: ', '');
      if (block.classList.contains('first_block') || title.includes('SELECTED MATERIALS') || title.includes('BACK CUSHION') || title.includes('BACK COUSIN') || /RYGHYNDE|RÜCKENKISSEN|RESPALDO/.test(title.toUpperCase())) return;
      const handleFromAttr = block.getAttribute('data-preview-handle');
      const optionHandle = handleFromAttr && handleFromAttr.trim()
        ? handleFromAttr.trim()
        : title
            .toLowerCase()
            .replace(/seat- and back- /g, '')
            .replace(/[|]/g, ' ')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
      const preview = this.section.querySelector(`.variant-preview[id*="-${CSS.escape(optionHandle)}"]`);
      const imageHtml = preview ? preview.innerHTML : '';
      html += `
        <div class="product-pop-up__selected-item">
          <div class="product-pop-up__item-image">${imageHtml}</div>
          <div class="product-pop-up__item-details">
            <h4 class="product-pop-up__item-title uppercase">${title}</h4>
            <p class="product-pop-up__item-value">${value}</p>
          </div>
        </div>
      `;
    });
    popupMaterials.innerHTML = html;

    const cushionChoice = modal.querySelector('.product-pop-up__cushion-choice');
    if (cushionChoice) {
      cushionChoice.style.display = this.requiresCushion ? '' : 'none';
    }

    this.resetPopupUI(modal);
    this.attachPopupListeners(modal);
  }

  /* -----------------------------
     Popup Helpers
  ----------------------------- */
  resetPopupUI(modal) {
    modal.querySelectorAll('.js-popup-option').forEach((opt) => opt.classList.remove('is-selected'));
    window._currentPopupSelection = null;
    const btn = modal.querySelector('#pop-up-add-to-basket');
    if (btn) { btn.disabled = false; btn.setAttribute('aria-disabled', this.requiresCushion ? 'true' : 'false'); }
    window.__sikaHint(modal, false);
    
    // Initialize info text with variant name | none
    this.handleCushionInfoText('none');
  }

  attachPopupListeners(modal) {
    // We remove any existing listener to prevent duplicate/stale handlers from previous instances
    if (window._handlePopupClick) modal.removeEventListener('click', window._handlePopupClick);
    if (window._handlePopupReset) modal.removeEventListener('dialog:after-hide', window._handlePopupReset);

    window._handlePopupClick = (e) => {
      const activeSync = document.querySelector('cushion-variant-sync');
      if (activeSync) activeSync.handlePopupClick(e, modal);
    };

    window._handlePopupReset = () => {
      const activeSync = document.querySelector('cushion-variant-sync');
      if (activeSync) activeSync.resetPopupState(modal);
    };

    modal.addEventListener('click', window._handlePopupClick);
    modal.addEventListener('dialog:after-hide', window._handlePopupReset);
  }

  resetPopupState(modal) {
    window._isProductPopupOpen = false;
    window._currentPopupSelection = null;
    modal.querySelectorAll('.js-popup-option').forEach((opt) => opt.classList.remove('is-selected'));
    const btn = modal.querySelector('#pop-up-add-to-basket');
    if (btn) { btn.disabled = false; btn.setAttribute('aria-disabled', 'true'); }
    window.__sikaHint(modal, false);
    const infoText = modal.querySelector('#pop-up-cushion-info-text');
    if (infoText) infoText.textContent = 'Ninguno';

    // Reset main selection if not confirmed
    if (!window._popupConfirmed) {
      this.querySelectorAll('input[name="choice"]').forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      window.__cushionChoice = null;
      this.syncCushionData(false);
    }
  }

  /* -----------------------------
     Popup Click Handler
  ----------------------------- */
  handlePopupClick(e, modal) {
    const option = e.target.closest('.js-popup-option');
    if (option) this.handlePopupOption(option, modal);
    const basketBtn = e.target.closest('#pop-up-add-to-basket');
    if (basketBtn) {
      if (basketBtn.getAttribute('aria-disabled') === 'true') window.__sikaHint(modal, true);
      else this.handleAddToBasket(modal);
    }
    const closeBtn = e.target.closest('[data-action="close"], .product-pop-up__header button');
    if (closeBtn) modal.removeAttribute('open');
  }

  handlePopupOption(option, modal) {
    modal.querySelectorAll('.js-popup-option').forEach((opt) => opt.classList.remove('is-selected'));
    option.classList.add('is-selected');
    const value = option.getAttribute('data-value').toLowerCase();
    this.handleCushionInfoText(value);
    window._currentPopupSelection = value;
    const btn = modal.querySelector('#pop-up-add-to-basket');
    if (btn) { btn.disabled = false; btn.setAttribute('aria-disabled', 'false'); }
    window.__sikaHint(modal, false);
    const activeSync = document.querySelector('cushion-variant-sync');
    const radio = activeSync?.querySelector(`input[id="${value}"]`);
    if (radio) radio.checked = true;
  }

  handleCushionInfoText(value) {
    const popupInfoText = document.querySelector('#pop-up-cushion-info-text');
    if (popupInfoText) {
      // Use fallback to find the section if this instance is detached
      const parent = this.section || document.querySelector('.shopify-section') || document.body;
      const labels = Array.from(parent.querySelectorAll('.variant-info-label'));
      const cushionLabelEl = labels.find(el => el.textContent.includes('TEJIDO:'));
      const infoLabel = cushionLabelEl ? cushionLabelEl.textContent.replace('TEJIDO:', '').trim() : '';

      if (value === 'yes') {
        const infoValue = cushionLabelEl?.closest('.variant-picker__option-info-labels')?.querySelector('.variant-info-value')?.textContent.trim() || 'none';
        popupInfoText.textContent = (infoLabel ? infoLabel + ' | ' : '') + infoValue;
      } else {
        popupInfoText.textContent = (infoLabel ? infoLabel + ' | ' : '') + ({ da: 'Ingen', de: 'Keine', es: 'Ninguno' }[(document.documentElement.lang || '').slice(0, 2)] || 'None');
      }
    }
  }

  handleAddToBasket(modal) {
    const activeSync = document.querySelector('cushion-variant-sync');
    if (!activeSync || !activeSync.productForm) return;

    if (activeSync.requiresCushion && window._currentPopupSelection) {
      const radio = activeSync.querySelector(`input[id="${window._currentPopupSelection}"]`);
      if (radio) {
        radio.checked = true;
        radio.click();
      }
    }

    window._isProductPopupOpen = false;
    window._popupConfirmed = true;
    const submitBtn = activeSync.productForm.querySelector('[type="submit"]');
    modal.removeAttribute('open');
    setTimeout(() => {
      submitBtn ? submitBtn.click() : activeSync.productForm.submit();
      
      setTimeout(() => {
        window._popupConfirmed = false;
      }, 500);
    }, 100);
  }

  /* -----------------------------
     Main Events
  ----------------------------- */
  handleClick(e) {
    const target = e.target;
    if (!target.classList?.contains('js-custom-checkbox')) return;
    window.__cushionChoice = target.id;
    this.querySelectorAll('.js-custom-checkbox').forEach((cb) => {
      cb.checked ? cb.setAttribute('checked', 'checked') : cb.removeAttribute('checked');
    });
  }

  handleChange(e) {
    if (e.target.name === 'choice') this.syncCushionData(true);
  }

  /* -----------------------------
     Helpers
  ----------------------------- */
  getLabelText(input) {
    return (input.labels?.[0]?.textContent || input.nextElementSibling?.textContent || '').trim();
  }

  /* -----------------------------
     Core Sync Logic
  ----------------------------- */
  syncCushionData(isUserInput = false) {
    const { section, dynamicText, infoBlock, lastBlock } = this;
    if (!section) return;
    const radio = this.querySelector('input[name="choice"]:checked');
    if (radio && dynamicText) {
      dynamicText.textContent = this.getLabelText(radio);
    }
    if (infoBlock && radio) infoBlock.classList.remove('hide');
    if (!lastBlock) return;
    const inputs = Array.from(lastBlock.querySelectorAll('input[type="radio"]'));
    let targetInput = null;
    if (radio?.id === 'yes') {
      targetInput = this.findYesVariant(section, inputs);
    } else {
      targetInput = this.findNoneVariant(inputs);
    }
    if (targetInput) this.applyVariantSelection(targetInput, isUserInput);
  }

  findYesVariant(section, inputs) {
    const activeTexts = Array.from(section.querySelectorAll('.variant-picker__option:not(.js-variant-last-block) input[type="radio"]:checked'))
      .map((input) => this.getLabelText(input))
      .filter(Boolean);
    let target = inputs.find((input) => !input.disabled && activeTexts.includes(this.getLabelText(input)));
    if (!target) {
      target = inputs.find((input) => !input.disabled && input.value.toLowerCase() !== 'none');
    }
    return target || inputs.find((i) => !i.disabled);
  }

  findNoneVariant(inputs) {
    return inputs.find((input) => {
      const text = this.getLabelText(input).toLowerCase();
      return (
        input.value.toLowerCase() === 'none' ||
        input.id.toLowerCase().includes('none') ||
        text.includes('none') ||
        window.__sikaIsNone(text)
      );
    });
  }

  applyVariantSelection(targetInput, isUserInput) {
    const needsEvent = isUserInput || !targetInput.checked || window.__lastSyncTarget !== targetInput.id;
    if (!needsEvent) return;
    window.__lastSyncTarget = targetInput.id;
    targetInput.checked = true;
    targetInput.setAttribute('checked', 'checked');
    targetInput.click();
    const eventOptions = { bubbles: true, cancelable: true };
    const event = new Event('change', eventOptions);
    event.noScroll = true; // Flag for VariantPicker/ProductGallery to skip scrolling
    targetInput.dispatchEvent(event);
    targetInput.dispatchEvent(new Event('input', eventOptions));
  }
}

/* -----------------------------
   Register Component
----------------------------- */
if (!window.customElements.get('cushion-variant-sync')) {
  customElements.define('cushion-variant-sync', CushionVariantSync);
}

